import { useState } from "react";
import { Toast, ToastBody } from "reactstrap";
import { Btn, Image } from "../../../../AbstractElements";
import { TopLeftToastTitle } from "../../../../Constants/Constants";
import { dynamicImage } from "../../../../Utils";

const TopLeftToast = () => {
  const [visible, setVisible] = useState(false);
  const toggle = () => setVisible(!visible);
  const handleClick = () => {
    setVisible(true);
    setTimeout(() => setVisible(false), 8000);
  };
  return (
    <>
      <Btn color="warning" onClick={handleClick}>
        {TopLeftToastTitle}
      </Btn>
      <div className="toast-container position-fixed start-0 top-0 p-3 toast-index toast-rtl">
        <Toast fade isOpen={visible} toggle={toggle}>
          <div className="toast-img toast-header">
            <Image className="rounded me-2" src={dynamicImage(`product-lists/profile.png`)} alt="profile" />
            <strong className="me-auto">{"Berlin Theme"}</strong>
            <small className="d-sm-block d-none">{"10 min ago"}</small>
            <Btn close className="p-0" onClick={toggle}></Btn>
          </div>
          <ToastBody className="toast-dark">
            <strong className="txt-success">{"Well done!"}</strong> {"You successfully read this important message."}
          </ToastBody>
        </Toast>
      </div>
    </>
  );
};
export default TopLeftToast;
